export type TurnstileRenderSize = "compact" | "flexible";

/** Cloudflare flexible mode still requires 300px; use compact below that threshold. */
export const TURNSTILE_FLEXIBLE_MIN_WIDTH = 300;

export function selectTurnstileSize(containerWidth: number): TurnstileRenderSize {
  return containerWidth >= TURNSTILE_FLEXIBLE_MIN_WIDTH ? "flexible" : "compact";
}
